import React, { useEffect, useRef, useState } from 'react';
import { FaClock, FaBolt, FaSmile, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const testimonials = [
  {
    quote: "This tool has saved us days of manual work.",
    name: "Ajay K., Civil Contractor",
    logo: "https://randomuser.me/api/portraits/men/76.jpg",
  },
  {
    quote: "No more Excel chaos — this made everything simpler.",
    name: "Ravi M., Consultant",
    logo: "https://randomuser.me/api/portraits/men/69.jpg",
  }
];

const metrics = [
  { label: 'Happy Customers', value: 512, suffix: '+', icon: <FaSmile className="text-2xl text-yellow-500" /> },
  { label: 'Days Saved per Month', value: 12, icon: <FaClock className="text-2xl text-orange-500" /> },
  { label: 'Efficiency Improvement', value: 3, suffix: 'x', icon: <FaBolt className="text-2xl text-green-600" /> },

];

const TrustTestimonials = () => {
  const [animatedValues, setAnimatedValues] = useState(metrics.map(() => 0));
  const sliderRef = useRef(null);

  // Counter animation
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimatedValues(prev =>
        prev.map((val, i) => (val < metrics[i].value ? val + 1 : val))
      );
    }, 50);
    return () => clearInterval(interval);
  }, []);

  // Auto-slide
  useEffect(() => {
    const autoScroll = setInterval(() => {
      scroll('right');
    }, 4000); // every 4s
    return () => clearInterval(autoScroll);
  }, []);

  const scroll = (direction) => {
    const container = sliderRef.current;
    const scrollAmount = 300;
    if (container) {
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Trust Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center mb-16">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition">
              <div className="flex justify-center mb-4">{metric.icon}</div>
              <div className="text-4xl font-bold text-gray-800">
                {animatedValues[index]}
                {metric.suffix || ''}
              </div>
              <div className="text-gray-600 mt-2 text-lg">{metric.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials Slider */}
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-10">What Our Users Say</h2>

        <div className="relative">
          {/* Left Button */}
          <button
            onClick={() => scroll('left')}
            className="absolute -left-4 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow z-10"
          >
            <FaChevronLeft className="text-gray-600" />
          </button>

          {/* Scrollable Testimonials */}
          <div
            ref={sliderRef}
            className="flex gap-6 overflow-x-auto scroll-smooth no-scrollbar px-2 py-2"
          >
            {testimonials.map((t, idx) => (
              <div
                key={idx}
                className="bg-gray-100 w-80 flex-shrink-0 p-6 rounded-xl shadow-md hover:shadow-lg transition"
              >
                {t.logo && (
                  <div className="w-16 h-16 mx-auto mb-4">
                    <img
                      src={t.logo}
                      alt={t.name}
                      className="w-full h-full object-cover rounded-full border-2 border-white shadow"
                    />
                  </div>
                )}
                <p className="text-gray-700 italic text-sm text-center mb-4">“{t.quote}”</p>
                <p className="text-center font-semibold text-gray-800">{t.name}</p>
              </div>
            ))}
          </div>

          {/* Right Button */}
          <button
            onClick={() => scroll('right')}
            className="absolute -right-4 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow z-10"
          >
            <FaChevronRight className="text-gray-600" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrustTestimonials;
